import React from 'react';
import { SectionConditionalTable } from './section-conditional-table';
import { SectionConditionalTableItems } from './section-conditional-table-items';
export function SectionSimple(props) {
    var backgroundColor = props.backgroundColor, borderBottom = props.borderBottom, borderLeft = props.borderLeft, borderRight = props.borderRight, borderTop = props.borderTop, children = props.children, cssClass = props.cssClass, direction = props.direction, fullWidth = props.fullWidth, padding = props.padding, textAlign = props.textAlign, width = props.width;
    return (React.createElement(SectionConditionalTable, { width: width, backgroundColor: backgroundColor },
        React.createElement("div", { className: fullWidth ? undefined : cssClass, style: {
                background: fullWidth ? undefined : backgroundColor,
                backgroundColor: fullWidth ? undefined : backgroundColor,
                margin: '0px auto',
                maxWidth: "".concat(width, "px"),
            } },
            React.createElement("table", { align: "center", border: "0", cellPadding: "0", cellSpacing: "0", role: "presentation", style: {
                    background: fullWidth ? null : backgroundColor,
                    backgroundColor: fullWidth ? null : backgroundColor,
                    width: '100%',
                } },
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", { style: {
                                borderBottom: borderBottom,
                                borderLeft: borderLeft,
                                borderRight: borderRight,
                                borderTop: borderTop,
                                direction: direction,
                                fontSize: '0px',
                                padding: padding,
                                textAlign: textAlign,
                            } },
                            React.createElement(SectionConditionalTableItems, null, children))))))));
}
//# sourceMappingURL=section-simple.js.map